import { Badge } from '@playerbase/ui';
import type { PlaytestDmDispatchState } from '@playerbase/types';

import type { TimelineDispatchCard } from '../../games/playtest-sessions-data.js';

interface Props {
  card: TimelineDispatchCard;
}

export function SessionDispatchCard({ card }: Props): JSX.Element {
  const { dispatch } = card;
  return (
    <div className="flex flex-col gap-1.5 rounded-md border border-border bg-surface px-3 py-2">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-2">
          <Badge>DM</Badge>
          <StatusBadge status={dispatch.status} />
        </div>
        <span className="text-xs text-text-muted">{formatTime(card.at)}</span>
      </div>
      <div className="text-xs text-text-muted">
        {dispatch.sentAt !== null ? `Sent ${formatTime(dispatch.sentAt)}. ` : null}
        {dispatch.respondedAt !== null
          ? `Responded ${formatTime(dispatch.respondedAt)}.`
          : null}
        {dispatch.lastError !== null ? ` Error: ${dispatch.lastError}` : null}
      </div>
    </div>
  );
}

const STATUS_TONE: Record<PlaytestDmDispatchState, 'neutral' | 'info' | 'success' | 'warning' | 'danger'> = {
  pending: 'neutral',
  claimed: 'info',
  sent: 'info',
  responded: 'success',
  expired: 'warning',
  failed: 'danger',
};

function StatusBadge({ status }: { status: PlaytestDmDispatchState }): JSX.Element {
  return (
    <Badge tone={STATUS_TONE[status]} aria-label={`DM ${status.replace('_', ' ')}`}>
      {status.replace('_', ' ')}
    </Badge>
  );
}

function formatTime(iso: string): string {
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return iso;
  return new Date(t).toLocaleString();
}
